export enum IssueUIMessages {
  LOAD_ISSUE_LIST_ERROR = 'An error occurred while loading the list of Issue.',
  LOAD_CUSTOMER_LIST_ERROR = 'An error occurred while loading the list of Customer.',
  LOAD_SHORT_DESCRIPTION_LIST_ERROR = 'An error occurred while loading the list of Short Description.',
  LOAD_SITE_LIST_ERROR = 'An error occurred while loading the list Sites.',
  LOAD_ISSUE_ERROR = 'An error occurred while loading the list of Issue.',
  UPDATE_ISSUE_ERROR = 'An error occurred while updating the Issue.',
  UPDATE_ISSUE_SUCCESS = 'Issue successfully edited.',
  DELETE_MESSAGE_TITLE = 'Delete Message',
  DELETE_MESSAGE_CONFIRMATION = 'Are you sure you want to delete message?',
  DELETE_MESSAGE_SUCCESS = 'Message successfully deleted.',
  DELETE_MESSAGE_ERROR = 'An error occurred while deleting the Message.',
  LOAD_ISSUE_SITE_MESSAGES = 'An error occurred while loading the list of Issue.',
  DELETE_SELFHELP_CONFIRMATION = 'Are you sure you want to delete self help?',
  DELETE_SELFHELP_TITLE = 'Delete Self Help',
  DELETE_SELFHELP_SUCCESS = 'Self help successfully deleted',
  DELETE_SELFHELP_ERROR = 'An error occurred while deleting self help.'
}
